var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fqt-base',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var fq = ref.fq;
return [_c('x-form-group',{attrs:{"title":"Options","label-for":"input-1"}},[_c('b-card',[_c('fq-values',{attrs:{"fq":fq},on:{"update:fq":function($event){fq=$event}}})],1)],1)]}}])},'fqt-base',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }